export default __webpack_public_path__ + "static/media/Chaturbhuj-Temple-1.0a35c3d1.jpg";